import React, { Fragment, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Typography from "@mui/material/Typography";
import { Col, Modal, Row } from "react-bootstrap";
import { useFormik } from "formik";
import { Button } from "../../common/Button";
import SelectFiled from "../../common/textfield/SelectFiled";
import SearchSelect from "../../common/textfield/SearchSelect";
import Fields from "./Fields";
import { getOrganization, getOrganizationSettings, getDiscover } from "../../api/Organization";
import { useSelector } from "react-redux";
import { failed, success } from "../../common/Toastify";
import { axios } from "../../../lib/axios";
import { FormikObjInboundCall } from "./Constant";
import moment from "moment";
import PatientSelection from "./PatientSelection";
import AddPatient from "./AddPatient";
import { useNavigate } from "react-router-dom";
import { editEncounter } from "../../apps/api/AppointmentRequests";
import { generatePass } from "../../apps/AppointmentRequests/Constants";
import { createQuestionnaireResponse, editQuestionnaireResponse, getQuestionnaireById } from "../../api/Questionnaire";
import { evaluateCondition } from "../../../utils/questionnaireSupport";
//import BookAppointment from "../../apps/AppointmentRequests/BookAppointment";
import Appointment from "../../apps/Appointments/Appointment";
import { getSingleUser, updatePatientDemographics, createExternalRegistryUser } from "../../api/Individual";
import { LOCATIONS } from "../../common/location";
import AddToWaitingRoomModal from "./AddToWaitingRoomModal";
import { getServiceLineById, getServiceLinesByOrgId } from "../../api/ServiceLine";
import { useGetOrgLicensedProducts } from "../../../hooks/ReactQueryHooks/useGetOrgLicensedProducts";
import { useConfirmDialog } from "../../../hooks/useConfirmDialog";
import { createEncounterInbound } from "../../apps/api/AppointmentRequests";
import { Resources } from "../../Zoom/Resources";

// changed to make steps language independant and step count independant
const ALL_STEPS = [
  {
    label: "Select Organization",
    key: "ORGANIZATION"
  },
  {
    label: "Intake Questionnaire",
    key:"QUESTIONS"
  },
  {
    label: "Patient Selection",
    key: "PATIENT"
  },
  {
    label: "How to proceed?",
    key:"FINISH"
  }
];
export const genderOptions = [
  { value: "male", name: "Male" },
  { value: "female", name: "Female" },
  { value: "other", name: "Other" },
];

export default function InBoundCall({
  encounterId: incomingEncounterId = null,
  encounteredData: incomingEncounterData = null,
  modalShow,
  handleShow,
  selectedPractitionerId=null,
}) {
  const user = useSelector((state) => state?.auth?.user);
  const navigate = useNavigate();
  const [btnLoading, setBtnLoading] = useState(false);
  const [disabledNext, setDisabledNext] = useState(false);
  const [isOrgReadOnly, setisOrgReadOnly] = useState(incomingEncounterId ? true : false);
  const [activeStep, setActiveStep] = useState(ALL_STEPS.find(item => item.key === "ORGANIZATION"));
  const [steps, setSteps] = useState(ALL_STEPS);
  const [patientModal, setPatientModal] = useState(false);
  const [skipped, setSkipped] = useState(new Set());
  const [Questions, setQuestions] = useState([]);
  const [questionnaireDefinition, setQuestionnaireDefinition] = useState(null);
  const [visibleQuestions, setVisibleQuestions] = useState([]);
  const [questionResponseKey, setQuestionResponseKey] = useState(0);
  const [isWaitingRoom, setIsWaitingRoom] = useState(null);
  const [organizations, setOrganizations] = useState([]);
  const [appointmentModal, setAppointmentModal] = useState(false);
  const [radioValue, setRadioValue] = useState([]);
  const [patient, setPatient] = useState(null);
  const [questionnairResId, setQuestionnairResId] = useState("");
  const [practitionerData, setPractitionerData] = useState(null);
  const adminOrgs = useSelector((state) => state?.auth?.user?.organizations);
  const [addToWRModalShow, setAddToWRModalShow] = useState(false);
  const [WRModalData, setWRModalData] = useState(null);
  const [availableServiceLines, setAvailableServiceLines] = useState([]);
  const { data: orgLicensedProducts } = useGetOrgLicensedProducts({})
  const is_VirtualCareEnabled = orgLicensedProducts?.virtualCare
  const { getConfirmation } = useConfirmDialog();
  const userRoles = user?.["cognito:groups"];
  const admin = userRoles?.includes("Super-Admin");
  const permissions = user?.permissions;
  const hasResourcesReadPermissions = admin || permissions?.some(permission => permission === "Access Resource Hub");
  const [resourceModalShow, setResourceModalShow] = useState(false);
  const [encounterId, setEncounterId] = useState(incomingEncounterId);
  const [encounteredData, setEncounteredData] = useState(incomingEncounterData);
  const [organizationSettings, setOrganizationSettings] = useState(null);
  const [wrEnabled, setWREnabled] = useState(false);
  const [vvEnabled, setVVEnabled] = useState(false);
  const [ccEnabled, setCCEnabled] = useState(true);
  const [allOrgData, setAllOrgData] = useState(null);
  const formik = useFormik({
    ...FormikObjInboundCall,
    enableReinitialize: true,
    onSubmit: (values, { setFieldError }) => {
      let topic = user?.name[0]?.text?.toLowerCase() + "fonemed";
      topic = topic.replace(" ", "") + Math.round(new Date().getTime() / 1000);
      let password = generatePass();
      if (activeStep.key === "ORGANIZATION") {
        if (values?.orgId === "") {
          setFieldError(`orgId`, "Required field");
          setDisabledNext(true);
          return true;
        } else if (values?.serviceLineId === "") {
          setFieldError(`serviceLineId`, "Required field")
          setDisabledNext(true);
          return true;
        } else {
          setDisabledNext(false);
          // setActiveStep(steps[steps.findIndex(step => step.key === "ORGANIZATION") + 1]);
        }
        if(!encounterId) {
          let encounterPayload = {
            orgId: values?.orgId,
            orgName: values?.orgName.trim(),
            requestedPeriod: {start: moment().utc().format("YYYY-MM-DDTHH:mm:ss[Z]"), end: null},
            practitionerId: user?.["custom:practitioner_id"] ?? practitionerData?.link?.[0]?.target?.reference?.split("/")?.[1],
            practitionerName: practitionerData?.name?.[0]?.text.trim(), 
            status: "in-progress-intake",
            statusHistory: [{
                status: "in-progress-intake",
                actor: {
                    reference: practitionerData?.link?.[0]?.target?.reference,
                    display: practitionerData?.name?.[0]?.text,
                },
                period: {
                    start: moment().utc().format("YYYY-MM-DDTHH:mm:ss[Z]"),
                    end: null
                }
            }] 
          }
          createEncounterInbound(encounterPayload).then((res)=>{
              if(res.status === true){ 
                setEncounterId(res.data.id); 
                setEncounteredData(res.data);
                setisOrgReadOnly(true);
              }else{
                failed(res?.response?.data?.message || res?.response?.data?.error || res.message) 
              }
          }).catch((res) => { 
              failed(res?.response?.data?.message || res?.response?.data?.error || res.message)
          }).finally();
        } else {
          setisOrgReadOnly(true);
        }
      } else if (activeStep.key === "QUESTIONS") {
        const telePhoneField = formik?.values?.questionResponse?.find(
          (item) => item?.tag === "TELEPHONE"
        )?.answer?.[0]?.answer;
        const pattern =
          /^(?:\+?1[-. ]?)?\(?[0-9]\d{2}\)?[-. ]?\d{3}[-. ]?\d{4}$/;
        const errList = values?.questionResponse?.map((question, index) => {
          if (visibleQuestions[index] && question?.required) {
            if (question?.answerType === "radio") {
              if (!question?.answer?.some((item) => !!item?.answer)) {
                setFieldError(`questionResponse[${index}]`, "Required field");
                return true;
              }
            } else if (
              question?.answerType === "freeText" ||
              question?.answerType === "singleFreeText" ||
              question?.answerType === "dropDown"
            ) {
              // if (question?.answer?.[0]?.answer?.length < 1 || !question?.answer?.[0]?.answer?.replace(/\s/g, "").length || question?.answer?.[1]?.answer?.length < 1 || !question?.answer?.[1]?.answer?.replace(/\s/g, "").length) {
              if (
                question.tag === "RELATIONSHIP" &&
                question?.answerType === "dropDown"
              ) {
                if (
                  question?.answer[0]?.answer === "" &&
                  radioValue.some(
                    (option) =>
                      option?.answer === true && option?.option === "No"
                  )
                ) {
                  setFieldError(`questionResponse[${index}]`, "Required field");
                  return true;
                }
              } else if (
                question.tag !== "RELATIONSHIP" &&
                question?.answerType === "dropDown" &&
                question?.answer[0]?.answer === ""
              ) {
                setFieldError(`questionResponse[${index}]`, "Required field");
                return true;
              }
              if (
                (question?.answerType === "freeText" || question?.answerType === "singleFreeText") &&
                question?.tag === "CALLER"
              ) {
                if (
                  question?.answer?.[0]?.answer === "" ||
                  question?.answer?.[0]?.answer === undefined
                ) {
                  setFieldError(`questionResponse[${index}]`, "Required field");
                  return true;
                }
                if (
                  question?.answer?.[1]?.answer === "" ||
                  question?.answer?.[1]?.answer === undefined
                ) {
                  setFieldError(`questionResponse[${index}]`, "Required field");
                  return true;
                }
              } else if (
                (question?.answerType === "freeText" || question?.answerType === "singleFreeText") &&
                question?.tag !== "CALLER"
              ) {
                if (
                  question?.answer?.[0]?.answer === "" ||
                  question?.answer?.[0]?.answer === undefined
                ) {
                  setFieldError(`questionResponse[${index}]`, "Required field");
                  return true;
                }
              }

              const firstName = values?.questionResponse.find(
                (obj) => obj.tag === "CALLER"
              )?.answer?.[0]?.answer;
              const lastName = values?.questionResponse.find(
                (obj) => obj.tag === "CALLER"
              )?.answer?.[1]?.answer;
              const indexAnswer = values?.questionResponse.findIndex(
                (obj) => obj.tag === "CALLER"
              );
              if (
                firstName === "" ||
                lastName === undefined ||
                lastName === ""
              ) {
                setFieldError(
                  `questionResponse[${indexAnswer}]`,
                  "Required field"
                );
                return true;
              }
              // }
            } else if (question?.answerType === "checkbox") {
              if (!question?.answer?.some((item) => !!item?.answer)) {
                setFieldError(`questionResponse[${index}]`, "Required field");
                return true;
              }
            }
          }
          return false;
        });

        if (
          formik?.values?.questionResponse?.length === 0 ||
          formik?.values?.questionResponse?.length === undefined ||
          formik?.values?.questionResponse?.length === null
        ) {
          return true;
        }
        if (!pattern.test(telePhoneField)) {
          return true;
        }


        localStorage.setItem(
          "firstName",
          values?.questionResponse.find((obj) => obj.tag === "CALLER")
            ?.answer?.[0]?.answer
        );
        localStorage.setItem(
          "lastName",
          values?.questionResponse.find((obj) => obj.tag === "CALLER")
            ?.answer?.[1]?.answer
        );
      } else if (activeStep.key === "PATIENT") {
        if (values?.patientId === "" && values?.selectedPatientData === "") {
          setFieldError(`patientId`, "Select patient before proceeding");
          return true;
        } else {
          // Check if selected organization has ecrEnabled ===true
          const selectedPatientData = values?.selectedPatientData;
          
          if (selectedPatientData && organizationSettings?.ecrEnabled === true) {
            const sources = Array.isArray(selectedPatientData?.source)
              ? selectedPatientData.source
              : selectedPatientData?.source
                ? [selectedPatientData.source]
                : [];
            const isExtOnly = sources.length === 1 && sources.includes("EXT");
            const isMatched = sources.includes("EXT") && sources.includes("FLZ");
            const hasDiscrepancy = !!selectedPatientData?.hasDemographicDiscrepancy;
            const demographicChoice = values?.demographicChoice;

            if (isMatched && hasDiscrepancy && !demographicChoice) {
              setFieldError(
                `patientId`,
                "Accept either local (FLZ) or Client Registry (EXT) demographics before proceeding"
              );
              return true;
            }

            if (isMatched && hasDiscrepancy && demographicChoice === "EXT") {
              // Update patient demographics from accepted EXT values (identifiers excluded)
            const sources = Array.isArray(selectedPatientData?.source)
              ? selectedPatientData.source
              : selectedPatientData?.source
                ? [selectedPatientData.source]
                : [];
            const isExtOnly = sources.length === 1 && sources.includes("EXT");
            const isMatched = sources.includes("EXT") && sources.includes("FLZ");
            const hasDiscrepancy = !!selectedPatientData?.hasDemographicDiscrepancy;
            const demographicChoice = values?.demographicChoice;

            if (isMatched && hasDiscrepancy && !demographicChoice) {
              setFieldError(
                `patientId`,
                "Accept either local (FLZ) or Client Registry (EXT) demographics before proceeding"
              );
              return true;
            }

            if (isMatched && hasDiscrepancy && demographicChoice === "EXT") {
              // Update patient demographics from accepted EXT values (identifiers excluded)
              setBtnLoading(true);
              const external = selectedPatientData?.external || {};
              const dob = moment(external?.birthDate).format("MM-DD-YYYY");

              const payload = {
                birthDate: (dob !== "Invalid date") ? dob : "",
                firstName: external?.name?.[0]?.given?.[0]?.trim() || "",
                lastName: external?.name?.[0]?.family?.trim() || "",
                gender: external?.gender?.trim() || "",
                firstName: external?.name?.[0]?.given?.[0]?.trim() || "",
                lastName: external?.name?.[0]?.family?.trim() || "",
                gender: external?.gender?.trim() || "",
                managingOrganization: values?.orgId,
                telecom: external?.telecom || [],
                address: external?.address || [],
                // Keep existing local identifiers (read-only; do not apply EXT identifier overwrite)
                identifier: selectedPatientData?.identifier || [],
                source: "EXT",
                // Audit keyword for patient service logging: user accepted EXT over local FLZ demographics
                auditAction: "USER_ACCEPTED_EXT_DEMOGRAPHICS_OVERRIDE",
                telecom: external?.telecom || [],
                address: external?.address || [],
                // Keep existing local identifiers (read-only; do not apply EXT identifier overwrite)
                identifier: selectedPatientData?.identifier || [],
                source: "EXT",
                // Audit keyword for patient service logging: user accepted EXT over local FLZ demographics
                auditAction: "USER_ACCEPTED_EXT_DEMOGRAPHICS_OVERRIDE",
              };

              updatePatientDemographics(values?.patientId, values?.orgId, payload)
                .then((res) => {
                  if (res?.status === true) {
                    const externalName =
                      external?.name?.[0]?.text?.trim() ||
                      [external?.name?.[0]?.given?.[0], external?.name?.[0]?.family]
                        .filter(Boolean)
                        .join(" ")
                        .trim() ||
                      values?.patientName;
                    // Encounter subject/participant display must use accepted EXT name
                    formik.setFieldValue("patientName", externalName);
                    success(res?.message || "Patient demographics updated successfully");
                  } else {
                    failed(res?.error || "Failed to update patient demographics");
                  }
                })
                .catch((res) => {
                  failed(
                    res?.response?.data?.message ||
                    res?.response?.data?.error ||
                    res?.message ||
                    "Error updating patient demographics"
                  );
                })
                .finally(() => setBtnLoading(false));
            } else if (isExtOnly && !selectedPatientData?.id) {
              // Pure ECR hit (no FLZ id yet) — create local patient from EXT demographics
              setBtnLoading(true);
              const email = selectedPatientData?.telecom?.find((t) => t?.system === "email")?.value || "";
              const firstIdentifier =
                selectedPatientData?.identifier?.find((item) => item?.type === "HCN") ||
                selectedPatientData?.identifier?.[0];
              const cleanedIdentifier = firstIdentifier ? (() => {
                const { source, ...identifierWithoutSource } = firstIdentifier;
                return [{
                  ...identifierWithoutSource,
                  type: "HCN"
                }];
              })() : [];
              
              const payload = {
                type: "Patient",
                name: selectedPatientData?.name,
                gender: selectedPatientData?.gender?.trim() || "",
                birthDate: selectedPatientData?.birthDate,
                telecom: selectedPatientData?.telecom,
                address: selectedPatientData?.address,
                managingOrganization: values?.orgId,
                identifier: cleanedIdentifier,
                email: email?.trim(),
                createAccount: false,
                source: "EXT",
                healthCardNumber: firstIdentifier?.value || "",
                healthCardAuthority: firstIdentifier?.system || "",
                healthCardNumber: firstIdentifier?.value || "",
                healthCardAuthority: firstIdentifier?.system || "",
              };

              createExternalRegistryUser(
                payload,
                values?.orgId,
                organizations
              )
                .then((res) => {
                  if (res?.status === true) {
                    success(res?.message || "User account created successfully");
                    formik.setFieldValue("patientId", res?.data?.link[0]?.target?.reference?.split("/")?.[1] || "");
                  } else {
                    failed(res?.error || "Failed to create user account");
                  }
                })
                .catch((res) => {
                  failed(
                    res?.response?.data?.message ||
                    res?.response?.data?.error ||
                    res?.message ||
                    "Error creating user account"
                  );
                })
                .finally(() => setBtnLoading(false));
            } else {
              // FLZ only, matched without discrepancy, or matched with FLZ choice — proceed without write
            }
          } else {
            // Patient is not EXTERNAL, proceed normally
          }
        }
      }} else if (activeStep.key ==="FINISH") {
        if (values.howToProceed === "") {
          setFieldError(`howToProceed`, "Required field");
          return true;
        } else {
          const requestedPeriod = [
            {
              start: moment().format("YYYY-MM-DDTHH:mm:ss[Z]"),
              end: moment().format("YYYY-MM-DDTHH:mm:ss[Z]"),
            },
          ];
          const getLocationQuestion = values.questionResponse.find(
            (question) => question.tag === "LOCATION"
          );
          let location = getLocationQuestion?.answer?.[0]?.answer;

          // if no location question, try to get it from a patient record
          if(!location && values?.selectedPatientData) 
            location = values?.selectedPatientData?.address?.[0]?.state;
          // if still no location, get it from the practitioner
          if((!location || location == "") && practitionerData) 
            location = practitionerData?.address?.[0]?.state;
          // if still no location, try for the organizations
          let org = allOrgData.find(org => org.id == formik.values?.orgId)
          if((!location || location == "") && org) 
            location = org?.address?.[0].country + "-" + org?.address?.[0]?.state;
                   
          let scopeOfJurisdiction = LOCATIONS[location];
          if (!scopeOfJurisdiction) {
            scopeOfJurisdiction = location;
          }
          if (values?.howToProceed === "COMPLETE_CALL") {
            setBtnLoading(true);
            const {concatenatedAnswerExt = null, concatenatedName = null, nameAnswer = null, telephoneAnswer = null} = extractIntakeData(values);
            const payload = buildQuestionnairePayload(values, telephoneAnswer, nameAnswer)
            
            if(!isWaitingRoom && values?.questionnaireId == "None") {
              let encounterPayload = buildEncounterPayload(values);
              if (scopeOfJurisdiction) {
                encounterPayload = {
                  ...encounterPayload,
                  patientLocation: scopeOfJurisdiction,
                };
              }
              editEncounter(encounterPayload)
                .then((resEncounter) => {
                  if (resEncounter.status === true) {
                    navigate("/app/interaction", {
                      state: {
                        practitionerName: user?.name?.[0]?.text.trim(),
                        practitionerId: user?.["custom:practitioner_id"], // changed from user["custom:unique_id"] to user?.["custom:practitioner_id"] to get the practitioner id
                        patientId: values?.patientId,
                        patientName: values?.patientName.trim(),
                        encounterId: encounterId,
                        currentUser: {
                          patient: { display: values?.patientName.trim() },
                        },
                        proceedWith: values?.howToProceed,
                        requestedPeriod: encounterPayload?.requestedPeriod,
                        questionnairInfo: null,
                          period: encounteredData?.period,
                          callInitiatedFrom: "inboundCall",
                        },
                      });
                      handleShow();
                      setBtnLoading(false);
                    }
                  })
                .catch((res) =>
                  failed(
                    res?.response?.data?.message ||
                    res?.response?.data?.error ||
                    res.message
                  )
                )
                .finally(() => setBtnLoading(false));              
            }
            else {
              handleQuestionnaireResponse(payload)
                .then(async (resQuestionnair) => {
                  localStorage.removeItem("firstName");
                  localStorage.removeItem("lastName");
                  if (resQuestionnair?.status === true) {
                    setQuestionnairResId(resQuestionnair?.data?.id);
                    const questionnairInfo = {
                      questionnaireResponseId: {
                        reference: `QuestionnaireResponse/${resQuestionnair?.data?.id}`,
                      },
                      callerName: values?.questionResponse.find(
                        (obj) => obj?.tag === "CALLER"
                      )?.answer?.[0]?.answer,
                      preferredChannel: "phone",
                    };
                    if (isTagPresent("TELEPHONE")) {
                      questionnairInfo["callerNumber"] =
                        getValueQuestionnair("TELEPHONE");
                    }
                    if (isTagPresent("REASON")) {
                      questionnairInfo["intakeReason"] =
                        getValueQuestionnair("REASON");
                    }
                    if (
                      isTagPresent("RELATIONSHIP") &&
                      isTagPresent("SELFCALLING")
                    ) {
                      if (getValueQuestionnairRadio("SELFCALLING") === "Yes")
                        questionnairInfo["callerRelationship"] = "Self";
                      else
                        questionnairInfo["callerRelationship"] =
                          getValueQuestionnairDropDown("RELATIONSHIP");
                    }
                    // For Proceed with Call, set intakePriorityReason on intakeQuestions (used by queue ingest)
                    questionnairInfo["intakePriorityReason"] = "Proceed with Call";
                    let encounterPayload = buildEncounterPayload(values, null, null, questionnairInfo);
                    if (scopeOfJurisdiction) {
                      encounterPayload = {
                        ...encounterPayload,
                        patientLocation: scopeOfJurisdiction,
                      };
                    }
                    editEncounter(encounterPayload)
                      .then((resEncounter) => {
                        if (resEncounter.status === true) {
                          navigate("/app/interaction", {
                            state: {
                              practitionerName: user?.name?.[0]?.text.trim(),
                              practitionerId: user?.["custom:practitioner_id"], // changed from user["custom:unique_id"] to user?.["custom:practitioner_id"] to get the practitioner id
                              patientId: values?.patientId,
                              patientName: values?.patientName.trim(),
                              encounterId: encounterId,
                              currentUser: {
                                patient: { display: values?.patientName.trim() },
                              },
                              proceedWith: values?.howToProceed,
                              requestedPeriod: requestedPeriod,
                              questionnairInfo: questionnairInfo,
                              period: encounteredData.period,
                              callInitiatedFrom: "inboundCall",
                            },
                          });
                          handleShow();
                          setBtnLoading(false);
                        }
                      })
                      .catch((res) =>
                        failed(
                          res?.response?.data?.message ||
                            res?.response?.data?.error ||
                            res.message
                        )
                      )
                      .finally(() => setBtnLoading(false));
                  }
                })
                .catch((res) =>
                  failed(
                    res?.response?.data?.message ||
                      res?.response?.data?.error ||
                      res.message
                  )
                )
                .finally(() => setBtnLoading(false));
              }
          } else if (values?.howToProceed === "SCHEDULE") {
            
            const { concatenatedAnswerExt = null, concatenatedName = null, nameAnswer = null, telephoneAnswer = null} = extractIntakeData(values);
            const payload = buildQuestionnairePayload(values, telephoneAnswer, nameAnswer)

            setBtnLoading(true);
            
            if(!isWaitingRoom && values.questionnaireId == "None") {
              setAppointmentModal(true);
              setBtnLoading(false);
            }
            else {
              handleQuestionnaireResponse(payload)
                .then((res) => {
                  setQuestionnairResId(res.data.id);
                  setAppointmentModal(true);
                  setBtnLoading(false);
                })
                .catch((res) => {
                  failed(
                    res?.response?.data?.message ||
                      res?.response?.data?.error ||
                      res.message
                  );
                })
                .finally(() => {
                  setBtnLoading(false);
                });
            }
          } else if (values?.howToProceed === "WAITING_ROOM") {
            setBtnLoading(true);
            
            const {concatenatedAnswerExt = null, concatenatedName = null, nameAnswer = null, telephoneAnswer = null} = extractIntakeData(values);
            const payload = buildQuestionnairePayload(values, telephoneAnswer, nameAnswer)

            handleQuestionnaireResponse(payload)
              .then(async (resQuestionnair) => {
                if (resQuestionnair?.status === true) {
                  setQuestionnairResId(resQuestionnair?.data?.id)
                  const questionnairInfo = {
                    questionnaireResponseId: {
                      reference: `QuestionnaireResponse/${resQuestionnair?.data?.id}`,
                    },
                    callerName: values?.questionResponse.find(
                      (obj) => obj?.tag === "CALLER"
                    )?.answer?.[0]?.answer,
                    preferredChannel: "phone",
                  };
                  if (isTagPresent("TELEPHONE")) {
                    questionnairInfo["callerNumber"] =
                      getValueQuestionnair("TELEPHONE");
                  }
                  if (isTagPresent("REASON")) {
                    questionnairInfo["intakeReason"] =
                      getValueQuestionnair("REASON");
                  }
                  if (
                    isTagPresent("RELATIONSHIP") &&
                    isTagPresent("SELFCALLING")
                  ) {
                    if (getValueQuestionnairRadio("SELFCALLING") === "Yes")
                      questionnairInfo["callerRelationship"] = "Self";
                    else
                      questionnairInfo["callerRelationship"] =
                        getValueQuestionnairDropDown("RELATIONSHIP");
                  }
                  let encounterPayload = buildEncounterPayload(values, null, null, questionnairInfo)
            
                  if (scopeOfJurisdiction) {
                    encounterPayload = {
                      ...encounterPayload,
                      patientLocation: scopeOfJurisdiction,
                    };
                  }
                  editEncounter(encounterPayload)
                    .then((resEncounter) => {
                      if (resEncounter.status === true) {
                        setWRModalData(encounterPayload);
                        setAddToWRModalShow(true);
                        //handleShow();
                        //setBtnLoading(false);
                      }
                    })
                    .catch((res) =>
                      failed(
                        res?.response?.data?.message ||
                          res?.response?.data?.error ||
                          res.message
                      )
                    )
                    .finally(() => setBtnLoading(false));
                }
              })
              .catch((res) =>
                failed(
                  res?.response?.data?.message ||
                    res?.response?.data?.error ||
                    res.message
                )
              )
              .finally(() => setBtnLoading(false));
          }
        }
      }
    },
  });

  // Warn on refresh/close : Warning only
  useEffect(() => {
    if (!modalShow || !encounterId) return;

    const handleBeforeUnload = (e) => {
      e.preventDefault();
      return e.returnValue;
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [modalShow, disabledNext, encounterId]);

  // Handle browser back button - Use handleClose()
  useEffect(() => {
    if (!modalShow || !encounterId) return;

    const handlePopState = async (e) => {
      window.history.pushState(null, '', window.location.href);
      await handleClose(encounterId);
    };

    window.history.pushState(null, '', window.location.href);

    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [modalShow, encounterId]);

  const isTagPresent = (tagValue) =>
    formik?.values?.questionResponse?.some((item) => item.tag === tagValue);
  const getValueQuestionnair = (tagValue) =>
    formik?.values?.questionResponse?.find((item) => item.tag === tagValue)
      ?.answer?.[0]?.answer;
  const getValueQuestionnairDropDown = (tagValue) =>
    formik?.values?.questionResponse
      .find((obj) => obj?.tag === tagValue)
      ?.answer?.find((val) => val?.answer !== "")?.answer;
  const getValueQuestionnairRadio = (tagValue) =>
    formik?.values?.questionResponse
      .find((obj) => obj?.tag === tagValue)
      ?.answer?.find((val) => val?.answer === true)?.option;

  const isStepOptional = (step) => {
    return step === 1;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = (submit = true) => {
    if(submit) {
      formik.submitForm().then(res => {
        if(!res) setActiveStep(steps[steps.findIndex(step => step.key == activeStep.key)+1] || steps[steps.length - 1])
      });
    }
    else setActiveStep(steps[steps.findIndex(step => step.key == activeStep.key)+1] || steps[steps.length - 1])
  };

  const handleBack = () => {
    setActiveStep(steps[steps.findIndex(step => step.key == activeStep.key)-1] || steps[0])
  };

  const handleReset = () => {
    setActiveStep(steps[0]);
  };

  useEffect(() => {
    getOrganization(adminOrgs?.[0]?.id)
      .then(async (res) => {
        setIsWaitingRoom(res?.data?.isWaitingRoom);
        if (res.data?.assignedQuestionnaire) {
          //const response = await axios.get(
          //  `questionnaire/${res.data?.assignedQuestionnaire?.["telephone-intake"]}`
          //);
          //formik.setFieldValue("questionnaireId", response?.data?.id);
          //setQuestions(
          //  response?.data?.item?.map((item) => ({
          //    ...item,
          //    name: item?.text,
          //    value: item?.id,
          //  }))
          //);
          //formik.setFieldValue(
          //  "questionResponse",
          //  Questions?.map((item) => {
          //    const isTrue =
          //      item?.answerType === "freeText" ||
          //      item?.answerType === "dropDown";
          //    const isDropDown = item?.answerType === "dropDown";
          //    return {
          //      ...item,
          //      answer: item?.answerOption?.map((option) => {
          //        return {
          //          id: option?.id,
          //          required: item?.required,
          //          answer: isTrue ? "" : false,
          //          option: isTrue ? isDropDown ? option.text : null : option?.text, 
          //          value: isDropDown ? option.text : null,
          //          name: isDropDown ? option.text : null,
          //        };
          //      }),
          //    };
          //  })
          //);
        }
      })
      .catch((res) => {
        failed(
          res?.response?.data?.message ||
            res?.response?.data?.error ||
            res.message
        );
      });

    getOrganization()
      .then((res) => {
         if (res?.data) { 
          setAllOrgData(res.data);
          const allOrgs = res.data.map((org) => ({
            ...org,
            value: org.id,
          }));
          allOrgs.sort((a, b) => a.name.localeCompare(b.name));
          setOrganizations(allOrgs); 
          const adminOrg = allOrgs.find(
            (org) => org.id === adminOrgs[0]?.id
          ); 

          if (encounterId && encounteredData) {
            formik.setFieldValue("orgId", encounteredData?.serviceProvider?.reference?.split("/")?.[1]);
            formik.setFieldValue("orgName", encounteredData?.serviceProvider?.display);
          }
          else if (adminOrg) {
            formik.setFieldValue("orgId", adminOrg.id);
            formik.setFieldValue("orgName", adminOrg.name);
          }
        }
      })
      .catch((res) => {
        failed(
          res?.response?.data?.message ||
            res?.response?.data?.error ||
            res.message
        );
      });

    getSingleUser({
      id: user["custom:unique_id"],
      type: "Practitioner",
      userOrgId: adminOrgs?.[0]?.id
    })
      .then((res) => {
        setPractitionerData(res.data);
      })
      .catch((res) => {
        console.log("error fetching practioner list", res);
      });

    if (encounteredData?.serviceLineId) {
      formik.setFieldValue("serviceLineId", encounteredData?.serviceLineId)
    }
  }, []);

  useEffect(() => {
    formik.setFieldValue(
      "questionResponse",
      Questions?.map((item) => {
        const isTrue =
          item?.answerType === "freeText" || item?.answerType === "singleFreeText" || item?.answerType === "dropDown";
        const isDropDown = item?.answerType === "dropDown";
        return {
          ...item,
          answer: item?.answerOption?.map((option) => {
            return {
              id: option?.id,
              required: item?.required,
              answer: isTrue ? "" : false,
              option: isTrue ? isDropDown ? option.text : null : option?.text,
              value: isDropDown ? option.text : null,
              name: isDropDown ? option.text : null,
            };
          }),
        };
      })
    );
  }, [Questions]);

  useEffect(() => {
    if (formik?.values?.orgId) {
      getServiceLinesByOrgId(formik?.values?.orgId).then((res) => {
        if (res?.status === true) {
          let formattedSL = res?.data?.map((dataItem) => ({
              name: dataItem?.name,
              value: dataItem?.id,
              id: dataItem?.id
            }));
          formattedSL.sort((a, b) => a.name.localeCompare(b.name));
          setAvailableServiceLines(formattedSL)

          if (encounteredData?.serviceLineId) {
            let findMatch = res?.data?.find((item) => item?.id === encounteredData?.serviceLineId)
            if (findMatch?.name) {
              formik.setFieldValue("serviceLineName", findMatch)
            }
          } else if (formattedSL?.length === 1 && formattedSL?.[0]?.id) {
            formik.setFieldValue("serviceLineName", formattedSL?.[0])
            formik.setFieldValue("serviceLineId", formattedSL?.[0]?.id)
          } else {
            formik.setFieldValue("serviceLineId", '') 
          }
        }
        getDiscover(formik.values?.orgId).then(settings => {
          setVVEnabled(settings?.data?.licensedProduct?.virtualCare)
          //setCCEnabled(settings?.data?.licensedProduct?.callCenter)
          setWREnabled(allOrgData.find(item => item.id == formik?.values?.orgId)?.isWaitingRoom || false)
        }).catch(settings => {
          failed(settings?.error || settings?.message || "Error getting Organizational Settings")
        }) 
      }).catch((res) => {
        failed(res?.error || res?.message || "Error getting Service Lines for Organization")
      })

    }
  }, [formik.values?.orgId])

  useEffect(() => {
    if (formik?.values?.serviceLineId && formik.values?.orgId) { 
      getServiceLineById(formik.values?.orgId, formik.values?.serviceLineId).then(async (res) => {
        if(!isWaitingRoom && res?.data?.intakeQuestionnaire === "None") {
          // this is ok, go straight to patient
          setSteps(ALL_STEPS.filter(
            (step) => !(step.key === "QUESTIONS")
          ));
          formik.setFieldValue("questionnaireId", "None");
          return;
        } 
        else if(!res?.data?.intakeQuestionnaire || res?.data?.intakeQuestionnaire === "None") {
          setSteps(ALL_STEPS);
          failed("No intake questionnaire found for this service line");
          setDisabledNext(true);
          return;
        } 
        else {
          setSteps(ALL_STEPS);
          setDisabledNext(false);
        }
        const response = await getQuestionnaireById(res?.data?.intakeQuestionnaire, res?.data?.orgId);
        formik.setFieldValue("questionnaireId", response?.data?.id);
        
        // Store the questionnaire definition with enableWhen from APL rules
        setQuestionnaireDefinition(response?.data);
        
        const questions = response?.data?.item?.map((item) => ({
          ...item,
          name: item?.text,
          value: item?.id,
        }));
        setQuestions(questions);

        const questionResponse = questions?.map((item) => {
          const isTrue =
            item?.answerType === "freeText" || item?.answerType === "singleFreeText" ||
            item?.answerType === "dropDown";
          const isDropDown = item?.answerType === "dropDown";
          return {
            ...item,
            questionId: item?.id || item?.linkId || null, // This must match the id in enableWhen expression
            tag: item?.tag,
            questionType: item?.answerType,
            answerType: item?.answerType,
            answer: item?.answerOption?.map((option) => {
              return {
                id: option?.id,
                required: item?.required,
                answer: isTrue ? "" : false,
                option: isTrue ? isDropDown ? option.text : null : option?.text, 
                value: isDropDown ? option.text : null,
                name: isDropDown ? option.text : null,
              };
            }),
          };
        });
        
        formik.setFieldValue("questionResponse", questionResponse);
      }).catch((res) => {
        failed(
          res?.response?.data?.message ||
            res?.response?.data?.error ||
            res?.message || "Error getting Service Line Intake Questionnaire"
        );
      });
    }

  }, [formik.values?.serviceLineId, formik.values?.orgId])

  // Evaluate APL rules and filter visible questions - re-evaluate whenever questionResponse changes
  useEffect(() => {
    if (!questionnaireDefinition || !formik.values?.questionResponse || Questions.length === 0) {
      if (Questions.length > 0) {
        setVisibleQuestions(Questions.map(() => true));
      }
      return;
    }

    const visibility = Questions.map((question, idx) => {
      let questionnaireItem = null;
      
      questionnaireItem = questionnaireDefinition?.item?.find(q => 
        q.id === question.id && q.linkId === question.linkId
      );

      if (!questionnaireItem) {
        questionnaireItem = questionnaireDefinition?.item?.find(q => q.linkId === question.linkId);
      }

      if (!questionnaireItem) {
        questionnaireItem = questionnaireDefinition?.item?.find(q => q.id === question.id);
      }
      if (!questionnaireItem?.enableWhen) return true;
      const questionResponse = formik.values.questionResponse.map((item, index) => ({
        ...item,
        questionId: item.questionId || item.id || Questions[index]?.id || Questions[index]?.linkId || null,
        tag: item?.tag,
        questionType: item.questionType || item.answerType,
        answerType: item.answerType || item.questionType,
      }));
      
      return evaluateCondition(questionnaireItem.enableWhen.expression, questionResponse);
    });
    
    setVisibleQuestions(visibility);
  }, [questionnaireDefinition, Questions, questionResponseKey, formik.values.questionResponse]);


  useEffect(() => {
    if(formik.values?.orgId) {
      getOrganizationSettings(formik.values?.orgId)
        .then((res) => {
          setOrganizationSettings(res?.data);
        })
        .catch((res) => {
          failed(
            res?.response?.data?.message ||
              res?.response?.data?.error ||
              res?.message ||
              "Error getting organization settings"
          );
        });
    }
  }, [formik.values?.orgId]);

  // Watch for changes in answer values to trigger re-evaluation
  useEffect(() => {
    if (!formik.values?.questionResponse || Questions.length === 0) return;
    
    // Create a hash of all answer values to detect changes
    const answerHash = formik.values.questionResponse.map(q => {
      if (q.answerType === 'radio' || q.answerType === 'checkbox') {
        return q.answer?.filter(a => a.answer === true).map(a => a.option).join(',');
      } else {
        return q.answer?.[0]?.answer || '';
      }
    }).join('|');
    
    // Trigger re-evaluation when answers change
    const timer = setTimeout(() => {
      setQuestionResponseKey(prev => prev + 1);
    }, 50);

    return () => clearTimeout(timer);
  }, [formik.values.questionResponse?.map(q => {
    if (q.answerType === 'radio' || q.answerType === 'checkbox') {
      return q.answer?.filter(a => a.answer === true).map(a => a.option).join(',');
    } else {
      return q.answer?.[0]?.answer || '';
    }
  }).join('|'), Questions.length]);

  const orgSelectOptions = organizations.map(org => ({ label: org.name, value: org.value }));
  const serviceLineSelectOptions = availableServiceLines.map(sl => ({ label: sl.name, value: sl.id }));

  const handleOrgChange = (selected) => {
    formik.setFieldValue("orgId", selected?.value || "");
    formik.setFieldValue("orgName", selected?.label || "");
    formik.setFieldValue("serviceLineId", "");
    formik.setFieldValue("serviceLineName", "");
    setVVEnabled(false);
    setWREnabled(false);
  };

  const handleServiceLineChange = (selected) => {
    formik.setFieldValue("serviceLineId", selected?.value || "");
    const selectedSL = availableServiceLines?.find((item) => item?.id === selected?.value);
    formik.setFieldValue("serviceLineName", selectedSL || "");
  }

  const getAnonymousPatient = (addedData) => {
    setPatient(addedData);
    formik.setFieldValue("selectedPatientData", addedData);
    formik.setFieldValue("patientId", addedData?.link[0]?.target?.reference?.split("/")?.[1] || "");
    formik.setFieldValue("patientName", addedData?.name?.[0]?.text);
    handleNext(false)
  }

  const getAddedPatient = (addedData) => {
    setPatient(addedData);
  };

  const resetPatient = (data) => {
    setPatient(data);
  };

  // if no questionnaire response id, create a new one, otherwise, update
  const handleQuestionnaireResponse = async (payload) => {
    if (questionnairResId) 
      return editQuestionnaireResponse(questionnairResId, payload)
    else
      return createQuestionnaireResponse(payload);
  }

  const activeForm = () => {
    switch (activeStep.key) {
      case "ORGANIZATION":
        return (
          <div>
          <Row>
            <Col>
              <SearchSelect
                label="Select Organization"
                required={true}
                options={orgSelectOptions}
                value={orgSelectOptions.find(opt => opt.value === formik.values.orgId) || null}
                onChange={handleOrgChange}
                placeholder="Select Organization"
                isDisabled={isOrgReadOnly}
                formik={formik}
                keyField="orgId"
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <SearchSelect
                label="Service Line"
                required={true}
                options={serviceLineSelectOptions}
                value={serviceLineSelectOptions.find(opt => opt.value === formik.values.serviceLineId) || null}
                onChange={handleServiceLineChange}
                placeholder="Select Service Line"
                isDisabled={!!encounteredData?.serviceLineId}
                formik={formik}
                keyField="serviceLineId"
              />
            </Col>
          </Row>
          </div>

          
        );
      case "QUESTIONS":
        return (
          <>
            {Questions?.length > 0 ? (
              Questions?.map((question, index) => {
                // Only render if question is visible based on APL rules
                if (!visibleQuestions[index]) return null;
                
                return (
                  <Fragment key={index}>
                    {/* <h6>{question?.text}{question?.required ? <span style={{ color: "red" }}> *</span> : null}</h6> */}
                    <Fields
                      question={question}
                      Questions={Questions}
                      formik={formik}
                      propIndex={index}
                      setRadioValue={(val) => {
                        setRadioValue(val);
                        // Force re-evaluation after a short delay to allow formik to update
                        setTimeout(() => setQuestionResponseKey(prev => prev + 1), 0);
                      }}
                    />
                    {/* <div>{formik?.errors?.questionResponse?.[index] ? <div className="error-text">Required question</div> : null}</div> */}
                  </Fragment>
                );
              })
            ) : (
              <div className="error-text">
                Assign the questionnaire to proceed.
              </div>
            )}
          </>
        );
      case "PATIENT":
        return (
          <PatientSelection
            orgId={formik?.values?.orgId}
            formikInBoundCall={formik}
            handleAddPatient={() => setPatientModal(true)}
            patient={patient}
            resetPatient={resetPatient}
            setPatient={getAnonymousPatient}
            onSearchLoadingChange={setBtnLoading}
          />
        );
      case "FINISH":
        return (
          <div style={{ padding: "10px" }}>
            <Row>
              { ccEnabled && 
              <Col
                style={{
                  border: "1px solid #c7c7c7",
                  padding: "10px",
                  borderRadius: "10px",
                  marginRight: "5px",
                }}
              >
                <label
                  style={{
                    display: "block",
                    cursor: "pointer",
                    width: "100%",
                    height: "100%",
                  }}
                >
                  <input
                    type="radio"
                    name="radio"
                    value={"COMPLETE_CALL"}
                    onChange={(e) =>
                      formik.setFieldValue("howToProceed", e.target.value)
                    }
                    style={{ marginRight: "5px" }}
                  />
                  Proceed with the call
                </label>
              </Col>
              }
              { vvEnabled && !isAnonymous()  && <Col
                style={{
                  border: "1px solid #c7c7c7",
                  padding: "10px",
                  borderRadius: "10px",
                  marginRight: "5px",
                }}
              >
                <label
                  style={{
                    display: "block",
                    cursor: "pointer",
                    width: "100%",
                    height: "100%",
                  }}
                >
                  <input
                    type="radio"
                    name="radio"
                    value={"SCHEDULE"}
                    onChange={(e) =>
                      formik.setFieldValue("howToProceed", e.target.value)
                    }
                    style={{ marginRight: "5px" }}
                  />
                  Schedule an Appointment
                </label>
              </Col>}
              { wrEnabled ? (
                <Col
                  style={{
                    border: "1px solid #c7c7c7",
                    padding: "10px",
                    borderRadius: "10px",
                  }}
                >
                  <label
                    style={{
                      display: "block",
                      cursor: "pointer",
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <input
                      type="radio"
                      name="radio"
                      value={"WAITING_ROOM"}
                      onChange={(e) =>
                        formik.setFieldValue("howToProceed", e.target.value)
                      }
                      style={{ marginRight: "5px" }}
                    />
                    Add to Waiting Room
                  </label>
                </Col>
              ) : null}
            </Row>
            <div>
              {formik?.errors?.howToProceed ? (
                <div className="error-text">{formik?.errors?.howToProceed}</div>
              ) : null}
            </div>
          </div>
        );
      default:
        return <Col></Col>;
    }
  };

  const isAnonymous = () => {
    if(patient) {
      return patient?.name?.find(item => item.use == "usual" && item.given.includes("Anonymous")) || false
    }
    else return false;
  }

  const extractIntakeData = (values) => {
    const results = {};

    const nameQuestion = values.questionResponse.find(
      (question) => question.tag === "CALLER"
    );
    if (nameQuestion) {
      let concatenatedName = null;
      let nameAnswer = nameQuestion?.answer;
      if(nameAnswer) 
        results["nameAnswer"] = nameAnswer;
      
      concatenatedName =
        nameQuestion?.answer?.[1] !== undefined
          ? nameAnswer[0]?.answer + " " + nameAnswer[1]?.answer
          : nameAnswer[0]?.answer;
      let namePatient =
        getValueQuestionnairRadio("SELFCALLING") === "Yes"
          ? values?.patientName
          : concatenatedName;
      nameAnswer.splice(1, 1);
      nameAnswer[0].answer = namePatient
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
      nameAnswer[0].required = true;
      nameAnswer[0].option = null;
      nameAnswer[0].value = null;
      nameAnswer[0].name = null;
      
      if(concatenatedName) 
        results["concatenatedName"] = concatenatedName;
    }

    const telephoneQuestion = values.questionResponse.find(
      (question) => question.tag === "TELEPHONE"
    );
    if (telephoneQuestion) {
      let telephoneAnswer = telephoneQuestion?.answer;
      
      if(telephoneAnswer) 
        results["telephoneAnswer"] = telephoneAnswer
      
      let concatenatedAnswerExt = null
      concatenatedAnswerExt =
        telephoneQuestion?.answer?.[1] !== undefined
          ? telephoneAnswer[0]?.answer +
            " ext " +
            telephoneAnswer[1]?.answer
          : telephoneAnswer[0]?.answer;
      telephoneAnswer.splice(1, 1);
      telephoneAnswer[0].answer = concatenatedAnswerExt.trim();
      telephoneAnswer[0].required = true;
      telephoneAnswer[0].option = null;
      telephoneAnswer[0].value = null;
      telephoneAnswer[0].name = null;

      if(concatenatedAnswerExt) 
        results["concatenatedAnswerExt"] = concatenatedAnswerExt
    }

    return results;
  }

  const buildQuestionnairePayload = (values, telephoneAnswer = null, nameAnswer = null) => {

    const setValue = item => {
      switch (item?.tag) {
        case "TELEPHONE":
          return telephoneAnswer;
        case "CALLER":
          return nameAnswer;
        default: 
          return item?.answer 
      }
    }

    const questionResponse = values.questionResponse?.map((item) => ({
      id: item?.linkId,
      tag: item?.tag,
      questionId: item?.id || null,
      question: item?.text.trim(),
      answer: setValue(item),
      questionType: item?.answerType,
      required: item?.required,
    }));
    let payload = {
      patientID: values.patientId,
      encounterId: "",
      questionResponse: questionResponse,
      appointmentId: "",
      encounterId: encounterId,
      questionnaire: values.questionnaireId,
      authorName: user?.name[0]?.text.trim(),
      authorType: "Practitioner",
      authorId: user["custom:practitioner_id"]
    }
    return payload
  }

  const buildEncounterPayload = (values, telephoneAnswer = null, nameAnswer = null, questionnaireInfo = null) => {
    let encounter = {};

    encounter.patient = {
      reference: `Patient/${values.patientId}`,
      type: "Patient",
      display: values?.patientName.trim(),    
    };
    encounter.orgId = values?.orgId;
    encounter.orgName = values?.orgName.trim();
    encounter.questionnaireInfo = questionnaireInfo                  
    encounter.requestedPeriod = {
      start: encounteredData?.period?.start,
      end: null,
    };
    encounter.practitionerId = user?.["custom:practitioner_id"] ?? practitionerData?.link?.[0]?.target?.reference?.split("/")?.[1];
    encounter.practitionerName = user?.name?.[0]?.text.trim();
    encounter.proceedWith = values?.howToProceed;
    if(values?.howToProceed === "COMPLETE_CALL")
      encounter.status = "in-progress-waitingroom";
    else if(values?.howToProceed === "WAITING_ROOM") {
      encounter.status = "in-progress-intake";
      encounter.statusHistory = [{
        status: "in-progress-intake",
        actor: {
          reference: practitionerData?.link?.[0]?.target?.reference,
          display: practitionerData?.name?.[0]?.text.trim(),
        },
        period: {
          start: moment().utc().format("YYYY-MM-DDTHH:mm:ss[Z]"),
          end: null
        }
      }];
      encounter.period = {
        start: encounteredData?.period?.start,
        end: null,
      };
    }
    encounter.encounterId = encounterId;
    encounter.serviceLineId = values?.serviceLineId;
    encounter.serviceLine = {
      reference: `ServiceLine/${values?.serviceLineId}`,
      display: values?.serviceLineName?.name || encounteredData?.serviceLine?.display,
      type: "ServiceLine"
    };
    encounter.actor = {
      reference: `Practitioner/${
        user?.["custom:practitioner_id"] ??
        practitionerData?.link?.[0]?.target?.reference?.split("/")?.[1]
      }`,
      display: user?.name?.[0]?.text.trim(),
      type: "Practitioner",
    };
    return encounter;
  }

  const handleClose = async (entryName) => {
    const confirmed = await getConfirmation({
      title: "Attention!",
      entryName,
      actionBtnTitle: "Yes",
      cancelBtnTitle: "No",
      actionFirst: true,
      message: "Are you sure you would like to cancel the encounter",
    });
    if (!confirmed) return;
    if(encounterId){
      if (confirmed) {
        let payload = {
          status: "cancelled",
          period: {
            start: encounteredData?.period?.start,
            end: moment().utc().format("YYYY-MM-DDTHH:mm:ss[Z]")
          },
          actor: {
            display: practitionerData?.name?.[0]?.text,
            reference: `Practitioner/${practitionerData?.id}`,
            type: "Practitioner"
          },
          class: "NULL"
        };
        setBtnLoading(true)
        return axios.put(`encounter/${encounterId}`, payload).then((res) => {
          if (res?.status === true) {
            success(res?.message)
            handleShow()
          }
        }).catch((res) => {
          failed(res?.message || "Error updating encounter")
        }).finally(() => setBtnLoading(false))
      }
    } else {
      handleShow()
    }
  }

  return (
    <>
      {patientModal && (
        <AddPatient
          formikInBoundCall={formik}
          modalShow={patientModal}
          handleShow={() => setPatientModal(false)}
          getAddedPatient={getAddedPatient}
        />
      )}
      {appointmentModal && (
        <Appointment
          questionnaireResponseId={questionnairResId}
          formikInbound={formik}
          type="intake"
          modalShow={appointmentModal}
          selectedOrgId={formik.values.orgId}
          // practitioner={selectedPractitionerId}
          handleHide={(completed = false) => {
            setAppointmentModal(false);
            if(completed) handleShow()
          }}
          handleShow={() => {
            handleShow();
          }}
          patient={formik.values.patientId}
          encounterId={encounteredData?.id}
        />
      )}
      {addToWRModalShow && (
        <AddToWaitingRoomModal
          data={WRModalData}
          onShow={addToWRModalShow}
          onHide={() => {
            setAddToWRModalShow(false);
          }}
          handleShow={() => handleShow()}
        />
      )}
      <Modal
        show={modalShow}
        onHide={() => handleClose(encounterId)}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdropClassName
        backdrop={"static"}
        dialogClassName="modal-xl-custom modal-xl-custom-resources"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Create New Encounter
          </Modal.Title>
          {hasResourcesReadPermissions && <Button className="custom-btn" 
            style={{ marginLeft: "auto", marginRight: "10px" }}
            title="Resources"
            variant="primary"
            onClick={() => setResourceModalShow(true)}>
              Resources
          </Button>}
          <Resources
            show={resourceModalShow}
            onHide={() => setResourceModalShow(false)}
            serviceLineId={formik.values.serviceLineId}
            encounterOrgId={formik.values.orgId}
          />
        </Modal.Header>
        <Modal.Body>
          <Box sx={{ width: "100%" }}>
            <Stepper activeStep={steps.findIndex(step => step.label == activeStep.label)}>
              {steps.map((label, index) => {
                const stepProps = {};
                const labelProps = {};
                // if (isStepOptional(index)) {
                //     labelProps.optional = (
                //     <Typography variant="caption">Optional</Typography>
                //     );
                // }
                if (isStepSkipped(index)) {
                  stepProps.completed = false;
                }
                return (
                  <Step key={label?.key} {...stepProps}>
                    <StepLabel {...labelProps}>{label.label}</StepLabel>
                  </Step>
                );
              })}
            </Stepper>
            {activeStep === steps.length ? (
              <React.Fragment>
                <Typography sx={{ mt: 2, mb: 1 }}>
                  All steps completed - you&apos;re finished
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                  <Box sx={{ flex: "1 1 auto" }} />
                  <Button onClick={handleReset}>Reset</Button>
                </Box>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <form
                  className="common-form border-fields"
                  style={{
                    border: "1px solid #c7c7c7",
                    padding: "10px",
                    borderRadius: "5px",
                    marginTop: "10px",
                  }}
                >
                  {activeForm()}
                </form>
                <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                {activeStep !== steps[0] && (
                  <Button
                    variant="secondary"
                    disabled={btnLoading}
                    onClick={handleBack}
                    sx={{ mr: 1 }}
                  >
                    Previous
                  </Button>
                )}
                  <Box sx={{ flex: "1 1 auto" }} />
                  <Button onClick={handleNext} disabled={disabledNext} isLoading={btnLoading}>
                    {activeStep === steps[steps.length - 1] ? "Proceed" : "Next"}
                  </Button>
                </Box>
              </React.Fragment>
            )}
          </Box>
        </Modal.Body>
      </Modal>
    </>
  );
}
